export enum LangContryCode {
  englisch = 'gb',
  german = 'de',
  irisch = 'ie',
  french = 'fr',
  italian = 'it',
  japanese = 'jp',
  polish = 'pl',
  chinese = 'cn',
  portugal = 'pt',
  brazil = 'br',
  korean = 'kp',
  spanish = 'es',
  dutch = 'nl',
  belgium = 'be',
  romanian = 'ro',
  usa = 'us',
  switzerland = 'ch',
  danish = 'dk',
  russian = 'ru',
  finnish = 'fi',
  czech = 'cz',
  hungarian = 'hu',
  greek = 'gr',
  latvian = 'lv',
  serbian = 'rs',
  turkish = 'tr',
  tagalog = 'ph',
  arabic = 'sy',
  estonian = 'ee',
  bulgarian = 'bg',
  bosnian = 'ba',
  aserbaidschanisch = 'az',
  norwegian = 'no',
  luxembourgian = 'lu',
  albanian = 'al',
  afrikaans = 'za',
  hindi = 'in',
  vietnamese = 'vn',
  zulu = 'za',
  slovak = 'sk',
  lithuanian = 'lt',
  thai = 'th',
  georgian = 'ge',
  urdu = 'pk',
  hebrew = 'il',
  indonesian = 'id',
  catalan = 'ad',
  uzbeklat = 'uz',
  tigrinya = 'er',
  taiwanese = 'tw',
  slovenia = 'si',
  swedish = 'se',
  persian = 'ir',
  montenegrin = 'me',
  metaDeutsch = 'de',
  macedonian = 'mk',
  maltese = 'mt',
  malayalam = 'in',
  malay = 'my',
  croatian = 'hr',
  khmer = 'kh',
  icelandic = 'is',
  armenian = 'am',
  ukrainian = 'ua',
  esperant = '',
  kurdish = '',
}
